// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// WARNING - Values under "firebase" and value of "googleApiKey" needs to be replaced from your own accounts
// If left as is, it firbase and google map related functionality will not work on LIVE instance.
export const environment = {
  production: false,
  // apiUrl: 'https://bus-api-stg.stg.vti.com.vn/api',
  // baseUrl: 'https://bus-api-stg.stg.vti.com.vn/',
  // apiUrl: 'https://jsh-api.vtibus.com/api',
  // baseUrl: 'https://jsh-api.vtibus.com',
    // apiUrl: 'http://localhost:8000/api',
    // baseUrl: 'http://localhost:8000',
  apiUrl: 'https://demo-buseye.facexpress.vn/api',
  baseUrl: 'https://demo-buseye.facexpress.vn',
  googleClientId: '361971034113-egi4rfsbtsp409tihkuourqgldko2s3u.apps.googleusercontent.com',
  facebookClientId: '',
  googleApiKey: 'AIzaSyCQ0aGDfkCVAA-OfsKCuSa-silgehayMqM',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
